<template>
    <div :class="!selecionouAlterarDados ? 'btn-alterar-dados' :  whiteBackground ? 'card' : 'form'" v-if="mostrar">

        <div v-if="selecionouAlterarDados">
            <p>Por favor, digite seu numero de celular</p> 
            <div class="input-flex">
                <input type="number" v-model="ddd" placeholder="DDD" maxlength="2" id="input1" />
                <input type="number" v-model="telefone" placeholder="000000000"    ref="input2" @keyup.enter="enviar"> 
                <button v-if="!loadingEnviarTelefone" class="form-btn" @click="enviar">Confirmar</button>
                <div v-if="loadingEnviarTelefone" class="btn-loading"><img src="../../assets/loading.gif" alt="" style="height: 35px"></div>
            </div>
        </div>
        <div v-if="!selecionouAlterarDados" style="justify-content: center;display: flex;">
            <button @click="onClickAlterarDados" class="btn-alterar-telefone">
                <img :style="{filter:corImagem}" src="../../assets/icons/editar.png" alt="">
                <!-- {{ numeroTel }} -->
                  Buscar pedidos com outro número
            </button>
        </div>
    </div>

</template>

<script>
import { setarCores } from '@/utils/SetarCores';
import Swal from 'sweetalert2';

export default {
    name: "TelefoneComDDD",
    props: {
        mostrar: Boolean,
        loadingEnviarTelefone: Boolean,
        whiteBackground: Boolean,
        botaoPequeno: Boolean,
        numeroTel:String
    },
    data() {
        return { 
            focus: false,
            ddd: "",
            // dddNovo:this.$store.state.numeroWhatsapp,
            // ddd:this.$store.state.numeroWhatsapp?.trim().length >= 3 ? this.$store.state.numeroWhatsapp.trim().substring(1, 3) : '',
            telefone: "",
            selecionouAlterarDados: true,
            corImagem:this.$store.state.corTexto === "white" ? 'invert(100%)' : 'invert(0%)',
        }
    },
    created() {
        setarCores(this.$store.state.cor1, this.$store.state.cor2,this.$store.state.corTexto)
    },
    computed: {
        clienteExisteNaBase() {
            if (this.ddd && this.telefone && this.telefone.length > 2) {
                return true
            }
            return false;
        }
    },
    methods: {
        buscarLocal() {
            this.ddd = localStorage.getItem('save-ddd')
            if(!this.ddd){
                this.ddd=this.$store.state.numeroWhatsapp?.trim().length >= 3 ? this.$store.state.numeroWhatsapp.trim().substring(1, 3) : '';
                console.log(this.$store.state.numeroWhatsapp)
            }
            this.telefone= localStorage.getItem('save-tel')
            if (this.ddd && this.telefone && this.telefone.length > 2) {
                this.selecionouAlterarDados = false
                this.enviar()
            }
        },
        
        enviar() {
            const ddd = String(this.ddd).trim();
            const tel = String(this.telefone).trim();
            const dddsValidos = [11,12,13,14,15,16,17,18,19,21,22,24,27,28,31,32,33,34,35,37,38,41,42,43,44,45,46,47,48,49,51,53,54,55,61,62,63,64,65,66,67,68,69,71,73,74,75,77,79,81,82,83,84,85,86,87,88,89,91,92,93,94,95,96,97,98,99];
            if (ddd.length !== 2 || !dddsValidos.includes(Number(ddd))) {
                Swal.fire({ icon: 'error', title: 'DDD inválido', text: 'Digite um DDD válido de 2 dígitos (ex: 11, 21, 31).' });
                return;
            }
            if (tel.length !== 9 || !tel.startsWith('9')) {
                Swal.fire({ icon: 'error', title: 'Número inválido', text: 'Digite um número de celular válido com 9 dígitos (ex: 912345678).' });
                return;
            }
            localStorage.setItem('save-ddd', this.ddd)
            localStorage.setItem('save-tel', this.telefone)
            this.$emit('callback',{telefone:  this.ddd + this.telefone})
            console.log('passou por aqui')
        },

        onClickAlterarDados() {
            this.selecionouAlterarDados = !this.selecionouAlterarDados
        },
    },
    mounted() {
        this.buscarLocal()
        this.$nextTick(() => {
        const input = this.$refs.input2;
        if (input) {
            input.focus();
        }
        });
    },
}
</script>

<style scoped >

p { margin-bottom: 10px;}

.input-flex {
    display: flex;
    width: 100%;
}
.input-flex input:first-child {
    width: 40px;
    margin-right: 10px;
}
.input-flex input:nth-child(2) {
    margin-right: 10px;
    flex-grow: 1;
}


.btn-enviar {
    min-width: 70px;
}

.btn-alterar-dados {
    z-index: 4;
}
.btn-alterar-telefone{
    height: 50px;
    width: 100%;
    border-radius: var(--border-radius-padrao);
    margin: var(--padding-padrao);
    color: var(--cor-texto);
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
}
.btn-alterar-telefone>img{
    object-fit: contain;
    padding-inline: var(--padding-padrao);
    width: 25px;
}
.btn-loading{
    background: transparent;
    min-width: 70px;
}
</style>